//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from "../../../lib/date";

export default {
    name: "businessDetail",
    components: {},
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            show: false,
            saving: false,
            shopId: 0,
            shop: {},
            couponCode: '',
            coupon: {
                coupon: {}
            },
            salesClerk: {}
        }
    },
    methods: {
        collectTicket() {
            // this.$router.push({path: '/business'})
            this.$router.back()
        },
        showPopup() {
            this.show = true;
        },
        getShop() {
            abp.ajax.get('/api/services/app/Shop/GetShopById?id=' + this.shopId).then(res => {
                this.shop = {};
                this.shop = res.data.result;
            })
        },
        getMyCouponByCode() {
            abp.ajax.get('/api/services/app/Coupon/GetMyCouponByCode?code=' + this.couponCode).then(res => {
                this.coupon = {};
                this.coupon = res.data.result;
            })
        },
        getSalesClerk() {
            var memberId = localStorage.getItem('MemberId');
            abp.ajax.get('/api/services/app/SalesClerk/GetSalesClerkByMemberIdAndShopId?memberId=' + parseInt(memberId) + '&shopId=' + this.shopId).then(res => {
                this.salesClerk = {};
                this.salesClerk = res.data.result;
            })
        },
        onRevokeCoupon() {

            var params = {
                code: this.couponCode,
                salesClerkId: this.salesClerk.id,
                shopId: this.shopId
            };
            this.saving = true;
            abp.ajax.post('/api/services/app/Coupon/RevokeCoupon', params).then(res => {
                this.show = true;
                this.getMyCouponByCode();
            }).finally(() => {
                this.saving = false
            })
        }

    },
    created() {
        this.shopId = parseInt(this.$route.params.shopId);
        this.couponCode = this.$route.params.code;
        this.getShop();
        this.getMyCouponByCode()
        this.getSalesClerk()
    }
}
